import { useEffect } from "react";
import type { QueryClient } from "react-query";
import { useChatStore } from "src/views/assistant/stores/ChatStore";
import type { WorkflowProductDescriptor } from "../types";

/** Point the shared ChatStore's product config at this workflow product. */
export const useSetWorkflowProductConfig = (
  product: WorkflowProductDescriptor,
) => {
  const { setProductConfig } = useChatStore();
  const { productKey, displayName, basePath } = product;

  useEffect(() => {
    setProductConfig({
      productKey,
      productName: displayName,
      basePath,
    });
  }, [setProductConfig, productKey, displayName, basePath]);
};

/**
 * Product config plus the recents URL builder, for history surfaces where a
 * row click must resolve a dialogue to this product's chat URL.
 */
export const useSetWorkflowRecentsConfig = (
  product: WorkflowProductDescriptor,
  queryClient: QueryClient,
) => {
  const { setProductConfig, registerChatUrlBuilder } = useChatStore();
  const { productKey, displayName, basePath, buildChatUrlForDialogue } =
    product;

  useEffect(() => {
    setProductConfig({
      productKey,
      productName: displayName,
      basePath,
    });
    if (buildChatUrlForDialogue) {
      registerChatUrlBuilder(productKey, buildChatUrlForDialogue(queryClient));
    }
  }, [
    setProductConfig,
    registerChatUrlBuilder,
    queryClient,
    productKey,
    displayName,
    basePath,
    buildChatUrlForDialogue,
  ]);
};
